module.exports = __webpack_public_path__ + "img/hotel8.93ac78c7.png";